export default __webpack_public_path__ + "static/media/lofiproto.93a9a524.jpg";